import ChatIconLarge from '@/assets/Onboarding/ChatIconLarge.svg';
import DottedLine from '@/assets/Onboarding/DottedLine.svg';
import FileIconLarge from '@/assets/Onboarding/FileIconLarge.svg';
import HeartIconLarge from '@/assets/Onboarding/HeartIconLarge.svg';
import { Button } from '@/components/ui/button';
import { useQuestionnaireNavigation } from '@/context/NavigationProvider';
import { PatientPageLayout } from '@/components/PatientPageLayout';

const steps = [
  {
    icon: ChatIconLarge,
    iconAlt: 'Discussion',
    label: 'Motifs - 2 min',
    description: 'Résumer les raisons\nde votre venue',
  },
  {
    icon: FileIconLarge,
    iconAlt: 'Dossier',
    label: 'Historique médical - 1 min',
    description: "Pour s'assurer que\ntout est à jour",
  },
  {
    icon: HeartIconLarge,
    iconAlt: 'Cœur',
    label: 'Prévention - 1 min (optionnel)',
    description: 'Faites le point sur\nvotre santé',
  },
];

export const QuestionnaireStepsOverview = () => {
  const { navigateNext } = useQuestionnaireNavigation();

  return (
    <PatientPageLayout
      title={
        <h1 className="text-2xl min-[23rem]:text-3.5xl font-semibold nxs:text-center leading-tight">
          Laissez-vous guider <br /> en 3 étapes rapides
        </h1>
      }
      footer={
        <div className="flex w-full  flex-col items-center mx-auto">
          <Button variant="ctaPrimary" size="lg" onClick={navigateNext}>
            Commencer
          </Button>
        </div>
      }
    >
      <div className="flex w-full max-w-[342px] flex-col items-center gap-8 py-4 mx-auto">
        <div className="relative flex w-full flex-col">
          <img
            src={DottedLine}
            className="pointer-events-none absolute left-7 top-10 w-3 h-35 min-[23.01rem]:left-12 min-[23.01rem]:top-26 min-[23.01rem]:w-5 object-fill object-left-top"
            aria-hidden
          />
          {steps.map((step, index) => (
            <div
              key={step.label}
              className={`relative flex items-center gap-3 py-2 ${
                index === 1 ? 'pl-6' : ''
              }`}
            >
              <div className="flex size-[46px] min-[23.01rem]:size-[100px] shrink-0 items-center justify-center rounded-3xl bg-white">
                <div className="flex size-[46px] min-[23.01rem]:size-[90px] items-center justify-center overflow-hidden rounded-[20px]">
                  <img
                    src={step.icon}
                    alt={step.iconAlt}
                    className="size-[46px] min-[23.01rem]:size-[90px] object-cover object-center"
                    width={90}
                    height={90}
                  />
                </div>
              </div>
              <div className="flex min-w-0 flex-1 flex-col gap-1.5">
                <p className="text-2xs font-semibold uppercase leading-tight tracking-[0.95px] text-gray-500">
                  {step.label}
                </p>
                <p className="whitespace-pre-line font-semibold leading-[1.2]">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </PatientPageLayout>
  );
};
